import { BenefitDTOBenefitEnum, DocumentsDTO } from 'probonio-shared-ui/api';
import { BenefitNavigationExtensionInterface } from '../../../../extension/interface/benefit-navigation.extension.interface';
import { BenefitMenuItemInterface } from '../../nav/BenefitMenuItem';

export class CustomBenefitNavigationExtension extends BenefitNavigationExtensionInterface {
  getMenuItems({ customBenefitId, documents }: { customBenefitId: string; documents: DocumentsDTO }): BenefitMenuItemInterface[] {
    const benefit = BenefitDTOBenefitEnum.Custom.toLowerCase();

    return [
      {
        title: 'subPage.employees',
        to: `/benefits/${benefit}/${customBenefitId}`,
      },
      { title: 'customBenefitsModule:configureButton', to: `/benefits/${benefit}/${customBenefitId}/edit` },
      ...(documents?.totalCount ? [{ title: 'subPage.documents', to: `/benefits/${benefit}/${customBenefitId}/documents` }] : []),
    ];
  }
}
